import request from '@/middleware/request'

const getSchedules = () => {
  return request({
    url: '/schedule',
    method: 'get'
  })
}

const createSchedule = data => {
  return request({
    url: '/schedule',
    method: 'post',
    data
  })
}

const updateSchedule = (id, data) => {
  return request({
    url: `/schedule/${id}`,
    method: 'patch',
    data
  })
}

const deleteSchedule = id => {
  return request({
    url: `/schedule/${id}`,
    method: 'delete'
  })
}

export default {
  getSchedules,
  createSchedule,
  updateSchedule,
  deleteSchedule
}
